import { render, staticRenderFns } from "./ConfigurationItemList.vue?vue&type=template&id=39f22737&"
import script from "./ConfigurationItemList.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationItemList.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationItemList.vue?vue&type=style&index=0&id=39f22737&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports